import Bootstrap from '../vendor/Bootstrap';
import Klaro from '../vendor/Klaro';
import FlatPickr from '../vendor/FlatPickr';

// Scripts that will be used globally on the front.

// Common global scripts
require('./common');
require('../brickables/carousel');
require('../utils/bugerOpenBehaviour');
// Temporary import, import accordion brick style for it to work on static pages
// TODO : find out how to include it dynamically
require('../brickables/accordion');

// Vendor
Bootstrap.tooltips();
Klaro.init();
FlatPickr.init();
